import React from "react";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";
import { withErrorBoundary } from "react-error-boundary";
import { ErrorComponent } from "components/common";
import { Error } from "components/error";

const Input = ({
	label,
	error = {},
	type = "text",
	className = "",
	placeholder,
	control,
	name,
	...rest
}) => {
	const { field } = useController({
		control,
		name,
		defaultValue: "",
	});
	return (
		<div className={`form-group pms-input-text relative ${className}`}>
			<label className="text-sm cursor-pointer" htmlFor={name}>
				{label}
			</label>
			<input
				className="text-15px placeholder:#999999 border-b-[#94BCDC] border-b w-full pb-2 pt-1 focus:border-b-blue-2 transition-all text-box single-line"
				type={type}
				id={name}
				placeholder={placeholder ? placeholder : `Nhập ${label}` }
				{...field}
				{...rest}
			/>
			{error && <Error>{error[name]?.message}</Error>}
		</div>
	);
};
Input.propTypes = {
	className: PropTypes.string,
	type: PropTypes.string,
	placeholder: PropTypes.string,
};

export default withErrorBoundary(Input, {
	FallbackComponent: ErrorComponent,
});
